module.exports = __webpack_public_path__ + "img/alert-danger.724f5230.svg";